
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/daily-activity",
      function () {
        return require("private-next-pages/dashboard/daily-activity/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/daily-activity"])
      });
    }
  